import React, { useState, useCallback } from 'react';
import { createRoot } from 'react-dom/client';
import { Typeahead } from '@swordsweeper/ssi-ui-component-library';

interface Clinic {
  id: number;
  text: string;
}

interface TypeaheadSuggestion {
  id: string;
  label: string;
  value: string;
}

function ClinicTypeaheadWidget() {
  const [inputValue, setInputValue] = useState('');
  const [suggestions, setSuggestions] = useState<TypeaheadSuggestion[]>([]);

  // Called by Typeahead on both typing and focus (valueTriggerLimit={0})
  const handleSearch = useCallback(async (query: string) => {
    try {
      const res = await fetch(`/public-clinics/?q=${encodeURIComponent(query ?? '')}`);
      const data = await res.json();
      setSuggestions(
        data.results.map((clinic: Clinic) => ({
          id: String(clinic.id),
          label: clinic.text,
          value: clinic.text,
        }))
      );
    } catch {
      setSuggestions([]);
    }
  }, []);

  const handleChange = (input: string | { target?: { value?: string } }) => {
    const value = typeof input === 'string' ? input : input?.target?.value ?? '';
    setInputValue(value);
    const hiddenInput = document.getElementById('id_clinic') as HTMLInputElement;
    if (hiddenInput) hiddenInput.value = '';
  };

  const handleSelect = (suggestion: TypeaheadSuggestion | null) => {
    const hiddenInput = document.getElementById('id_clinic') as HTMLInputElement;
    if (!suggestion) {
      setInputValue('');
      if (hiddenInput) hiddenInput.value = '';
      return;
    }
    setInputValue(suggestion.label);
    if (hiddenInput) hiddenInput.value = suggestion.id;
  };

  return (
    <Typeahead
      placeholder="Search for your clinic..."
      value={inputValue}
      suggestions={suggestions}
      onChange={handleChange}
      onSearch={handleSearch}
      onSelect={handleSelect}
      clearable
      inputWidth="100%"
      valueTriggerLimit={0}
      showTopOverride={false}
    />
  );
}

const container = document.getElementById('clinic-typeahead-root');
if (container) {
  createRoot(container).render(<ClinicTypeaheadWidget />);
}
